module.exports = __webpack_public_path__ + "static/media/uploaddce403d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/therapist/images/galleryUploadIcons/upload.svg
// module id = 1243
// module chunks = 0